import Hero from "../components/Hero";
import WhatWeOrchestrate from "../components/WhatWeOrchestrate";
import SolutionsInMotion from "../components/SolutionsInMotion";
import SystemThinks from "../components/SystemThinks";
import Deployments from "../components/Deployments";
import Impact from "../components/Impact";
import FromLinkedIn from "../components/FromLinkedIn";
import CTA from "../components/CTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <WhatWeOrchestrate />
      <SolutionsInMotion />
      <SystemThinks />
      <Deployments />
      <Impact />
      <FromLinkedIn />
      <CTA />
    </div>
  );
}
